import { formatDateWithAmPm, getStatusClass } from "../../Style";

export const customHeaders=(tab,page) => [
  { 
    field: "vendor_serial_no", 
    header: "Vendor ID",
    isClickable: true,
     onClick: (row) => ({
      pathname: `/vendors/view/${row.id}`,
      state: { tab: tab, page: page }, // 👈 extra state
    }),
    // onClick: (row) => {
    //   return `/vendors/view/${row.id}`;
    // }
  },
  { field: "agency_name", header: "Company Name", sortable: true },
  {
    field: "fullName",
    header: "Full Name",
    render: (_, row) => {
      const firstName = row.first_name ? row.first_name.trim() : "";
      const lastName = row.last_name ? row.last_name.trim() : "";
      const fullName = `${firstName} ${lastName}`.trim();

      return fullName || "Unknown Name";
    },
    sortable: true
  },
  { field: "email", header: "Email" },
  { field: "phone", header: "Mobile" },
  {
    field: "last_active",
    header: "Last Active",
    render: (value) => (value ? formatDateWithAmPm(value) : "-")
  },
  {
    field: "created_at",
    header: "Created Date",
    render: (value) => (value ? formatDateWithAmPm(value) : "-"),
    sortable: true
  },
  {
    field: "status",
    header: "Vendor Status",
    render: (value) => (
      <span
        className={`badge ${getStatusClass(
          value === 1 ? "Active" : "Inactive"
        )}`}
      >
        {value === 1 ? "Active" : "Inactive"}
      </span>
    )
  },
  {
    field: "approove_status",
    header: "Approval Status",
    render: (value) => (
      <span
        className={`badge ${getStatusClass(
          value === 1 ? "Approved" : value === 2 ? "Pending" : "Rejected"
        )}`}
      >
        {value === 1 ? "Approved" : value === 2 ? "Pending" : "Rejected"}
      </span>
    )
  }
];